import { AxiosResponse } from 'axios';
import { SET_ALLOWANCE_TYPES, SET_ALLOWANCE_TYPE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_ALLOWANCE_TYPE_ISLOADING,
  DELETE_ALLOWANCE_TYPE,
  EDIT_ALLOWANCE_TYPE,
  GET_ALLOWANCE_TYPES,
  GET_ALLOWANCE_TYPE,
  REGISTER_ALLOWANCE_TYPE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import AllowanceType from '@/services/allowance_type';
import { Module } from 'vuex';
import { EditAllowanceType, RegisterAllowanceType, GetAllowanceType } from '@/dtos/allowance_type.dto';

const allowanceType: Module<any, {}> = {
  state: {
    allowanceType: {
      data: null,
      isLoading: false,
    },
    allowanceTypes: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    allowanceType: (state: { allowanceType: any }) => state.allowanceType,
    allowanceTypes: (state: { allowanceTypes: any }) => state.allowanceTypes,
  },
  mutations: {
    [SET_ALLOWANCE_TYPE]: (
      state: { allowanceType: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.allowanceType.data = payload.data) : null,
        (state.allowanceType.isLoading = payload.isLoading);
    },
    [SET_ALLOWANCE_TYPES]: (
      state: { allowanceTypes: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.allowanceTypes.data = payload.data) : null,
        (state.allowanceTypes.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_ALLOWANCE_TYPE]: async ({ commit }: any, payload: any) => {
      commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await AllowanceType.registerAllowanceType(
        payload as RegisterAllowanceType
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ALLOWANCE_TYPE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ALLOWANCE_TYPE, { isLoading: false });
        return false;
      }
    },
    [GET_ALLOWANCE_TYPES]: async ({ commit }: any, payload: any) => {
      commit(SET_ALLOWANCE_TYPES, { data: null, isLoading: true });

      const result: AxiosResponse = await AllowanceType.getAllowanceTypes(
        payload as GetAllowanceType
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ALLOWANCE_TYPES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ALLOWANCE_TYPES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ALLOWANCE_TYPES, { isLoading: false });
        return false;
      }
    },
    [GET_ALLOWANCE_TYPE]: async ({ commit }: any, payload: any) => {
      commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await AllowanceType.getAllowanceTypes(
        payload as GetAllowanceType
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ALLOWANCE_TYPE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ALLOWANCE_TYPE, { isLoading: false });
        return false;
      }
    },
    [EDIT_ALLOWANCE_TYPE]: async ({ commit }: any, payload: any) => {
      commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await AllowanceType.editAllowanceType(
        payload as EditAllowanceType
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ALLOWANCE_TYPE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ALLOWANCE_TYPE, { isLoading: false });
        return false;
      }
    },
    [DELETE_ALLOWANCE_TYPE]: async ({ commit }: any, payload: string) => {
      commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: true });

      const result: AxiosResponse = await AllowanceType.deleteAllowanceType(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ALLOWANCE_TYPE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ALLOWANCE_TYPE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ALLOWANCE_TYPE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ALLOWANCE_TYPE_ISLOADING]: ({ commit }) => {
      commit(SET_ALLOWANCE_TYPE, { isLoading: false });
      commit(SET_ALLOWANCE_TYPES, { isLoading: false });
    },
  },
};

export default allowanceType;
